import styled from 'styled-components';

import { RewardsCarousel } from 'components/rewards-carousel';
import { primitive } from 'styles/constants/primitives';

import { CarouselItem, CarouselItemPoints } from '../loyalty-rewards/loyalty-rewards.styled';

export const CarouselSectionRewards = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  margin: 1rem auto;
  list-style: none;
`;

export const CarouselRewardItem = styled.div`
  position: relative;
  background: white;
  width: 9.375rem;
  height: 15.5rem;
  border-radius: 0.75rem;
  margin-block-start: 1rem;
  margin-block-end: 0;
  margin-inline: 0;
  padding-block-start: 0;
  padding-block-end: 0.3rem;
  padding-inline: 0.3rem;
  cursor: pointer;

  ${Styles.desktop} {
    width: 18.75rem;
    height: 16.625rem;
    margin: 0 1rem;
  }
`;

export const CardWrapper = styled.div<{ locked?: boolean }>`
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const PictureWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 6.8rem;
  margin-block-start: 0.75rem;
`;

export const LockOverlay = styled.div`
  width: calc(100% - 1rem);
  height: 6.5rem;
  position: absolute;
  inset-block-start: 0;
  inset-inline-start: 0;
  background: ${primitive.$black};
  border-radius: 0.5rem;
  margin: 0 0.5rem;
  opacity: 0.5;
`;

export const CarouselRewardName = styled.div`
  font-family: 'Flame';
  font-style: normal;
  font-weight: 400;
  font-size: 1rem;
  text-align: center;
  color: ${primitive.bk.$bbqBrown};
  max-height: 3rem;
  line-height: 1.5rem;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  margin-block-end: 0.25rem;
`;

export const CarouselRewardDescription = styled.div`
  height: 1rem;
  color: ${primitive.bk.$bbqBrown};
  overflow: hidden;
  text-align: center;
  text-overflow: ellipsis;
  font-family: Flame Sans;
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 400;
  line-height: 1rem;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  margin-block-end: 0.5rem;
`;

export const CarouselPoints = styled(CarouselItemPoints)`
  margin-block-start: auto;
  margin-block-end: 0.85rem;

  ${Styles.desktop} {
    margin-block-end: 1.25rem;
  }
`;

export const LastCarouselItem = styled(CarouselItem)`
  margin-inline-end: 1.5rem;
  height: unset;
  background: ${primitive.bk.$mayoEggWhite};

  ${Styles.desktop} {
    margin-inline-end: 0;
  }
`;

export const StyledRewardsCarousel = styled(RewardsCarousel)`
  margin-inline-start: -1rem;
  margin-block-end: -1.5rem;

  [data-testid='scrollbar-wrapper'] {
    display: none;
  }
`;

export const LastItemWrapper = styled.div`
  height: 100%;
  padding: 0 1rem;
`;

export const LastItemContent = styled.div`
  display: flex;
  height: 100%;
  align-items: center;
  font-family: Flame Sans;
  font-size: 1.125rem;
  font-style: normal;
  font-weight: 400;
  line-height: 1.25rem;
  color: ${primitive.bk.$bbqBrown};
`;
